export const homeEventsConfig = {
    // parentSelector: 'body.template-index', // Scopes events to the homepage template
    events: {
        homeBannerNextClick: {
            selector: 'slideshow-component .slideshow__controls .slider-button--next', 
            event: {
                event: 'user_interaction',
                component: 'banner_slider',
                element: 'chevron',
                action: 'click',
                action_value: 'next',
                trigger: 'click'
            }
        },

        homeBannerPrevClick: {
            selector: 'slideshow-component .slideshow__controls .slider-button--prev',
            event: {
                event: 'user_interaction',
                component: 'banner_slider',
                element: 'chevron',
                action: 'click',
                action_value: 'previous',
                trigger: 'click'
            }
        },

        homeBannerPlayPauseClick: {
            selector: 'slideshow-component .slideshow__controls .slider__autoplay',
            event: {
                event: 'user_interaction',
                component: 'banner_slider',
                element: 'icon',
                action: 'click',
                trigger: 'click',
                getDynamicData: (element) => {
                    // Determine state based on aria-label
                    const isPlaying = element.getAttribute('aria-label')?.includes('pauzeren'); 
                    return {
                        action_value: isPlaying ? 'pause' : 'play' 
                    };
                }
            }
        },

        // == Category Slider (Lines 182-184) ==

        homeCategorySliderNextClick: {
            // Use attribute selector for section type
            selector: 'section[id*="__collection_list"] .slider-button--next', 
            event: {
                event: 'user_interaction',
                component: 'category_slider',
                element: 'chevron',
                action: 'click',
                action_value: 'next',
                trigger: 'click',
                getDynamicData: () => ({
                    slider_name: 'Populaire categorieën' // Static for this slider
                })
            }
        },

        homeCategorySliderPrevClick: {
             // Use attribute selector for section type
            selector: 'section[id*="__collection_list"] .slider-button--prev',
            event: {
                event: 'user_interaction',
                component: 'category_slider',
                element: 'chevron',
                action: 'click',
                action_value: 'previous',
                trigger: 'click',
                getDynamicData: () => ({
                    slider_name: 'Populaire categorieën' // Static for this slider
                })
            }
        },

        homeCategorySliderCardClick: {
            // Use attribute selector for section type
            selector: 'section[id*="__collection_list"] .collection-list__item a', 
            event: {
                event: 'user_interaction',
                component: 'category_slider',
                element: 'card',
                action: 'click',
                trigger: 'click',
                getDynamicData: (element) => { // element is the <a> tag
                    const titleElement = element.querySelector('.card__heading__collection-title-box span');
                    return {
                        slider_name: 'Populaire categorieën', // Static for this slider
                        // category_name: titleElement ? titleElement.textContent.trim() : 'Unknown Category', // Get category name from card title
                        link_url: element.href
                    };
                }
            }
        },

        // == Product Slider (Lines 185-188) ==

        homeProductSliderNextClick: {
            // Use attribute selector for section type
            selector: 'section[id*="__featured_collection"] .slider-button--next', 
            event: {
                event: 'user_interaction',
                component: 'product_slider',
                element: 'chevron',
                action: 'click',
                action_value: 'next',
                trigger: 'click',
                getDynamicData: () => ({
                    slider_name: 'Uitgelichte producten' // Static for this slider
                })
            }
        },

        homeProductSliderPrevClick: {
             // Use attribute selector for section type
            selector: 'section[id*="__featured_collection"] .slider-button--prev',
            event: {
                event: 'user_interaction',
                component: 'product_slider',
                element: 'chevron',
                action: 'click',
                action_value: 'previous',
                trigger: 'click',
                getDynamicData: () => ({
                    slider_name: 'Uitgelichte producten' // Static for this slider
                })
            }
        },

        homeProductSliderCardClick: {
            // Use attribute selector for section type
            selector: 'section[id*="__featured_collection"] .card-wrapper .card__heading a', 
            event: {
                event: 'user_interaction',
                component: 'product_slider',
                element: 'card',
                action: 'click',
                trigger: 'click',
                getDynamicData: (element) => { // element is the <a> tag
                     // Prevent firing if ATC button within the card was clicked
                    if (element.closest('product-form')) return null; 
                    
                    const cardWrapper = element.closest('.card-wrapper');
                    const productName = element.textContent.trim();
                    return {
                        slider_name: 'Uitgelichte producten',
                        product_name: productName,
                        link_url: element.href
                    };
                }
            }
        },

        homeProductSliderATC: {
             // Use attribute selector for section type
            selector: 'section[id*="__featured_collection"] .quick-add__submit', 
            event: {
                event: 'user_interaction',
                component: 'product_slider',
                element: 'cta_button',
                action: 'click',
                action_value: 'add_to_cart',
                trigger: 'click',
                getDynamicData: (element) => { // element is the button
                    const cardWrapper = element.closest('.card-wrapper');
                    const productNameElement = cardWrapper?.querySelector('.card__heading a'); 
                    const productName = productNameElement ? productNameElement.textContent.trim() : 'Unknown Product';
                    // Get text from the button itself or its span
                    const buttonText = element.querySelector('span.medium-hide.small-hide') ?.textContent.trim() || element.textContent.trim() || 'Aan winkelwagen toevoegen';
                    return {
                        slider_name: 'Uitgelichte producten',
                        product_name: productName,
                        click_text: buttonText
                    };
                }
            }
        },

        // == General CTA Button (Line 189) ==
        homeShopRobotsCTA: {
            selector: '#shopify-section-template--25200253534543__image_with_text_KQHGJL a.button', 
            event: {
                event: 'user_interaction',
                component: '', // Component is blank in CSV example
                element: 'cta_button',
                action: 'click',
                trigger: 'click',
                getDynamicData: (element) => { // element is the <a> tag
                    const section = element.closest('.image-with-text');
                    const headingElement = section?.querySelector('h2.image-with-text__heading');
                    const buttonSpan = element.querySelector('span');
                    return {
                        field_name: headingElement ? headingElement.textContent.trim() : 'Unknown Section', // Use section heading as field_name
                        click_text: buttonSpan ? buttonSpan.textContent.trim() : 'Shop Robots', // Get text from span
                        link_url: element.href
                    };
                }
            }
        },

        // == FAQ Section (Lines 190-192) ==
        homeFaqAccordionToggle: {
            // Use class for section type, more specific to FAQ/collapsible content
            selector: '.collapsible-content-section details summary',
            event: {
                event: 'user_interaction',
                component: 'faq',
                element: 'accordion',
                action: 'click', // Simplified from open/close
                trigger: 'click',
                getDynamicData: (element) => { // element is the <summary>
                    const titleElement = element.querySelector('.accordion__title');
                    return {
                        // Use accordion title text as field_name
                        field_name: titleElement ? titleElement.textContent.trim() : 'Unknown FAQ Item' 
                    };
                }
            }
        },

        homeFaqLinkClick: {
             // Target links within the accordion content in the FAQ section
            selector: '#shopify-section-template--25200253534543__8f5a111c-95e5-4fe4-9470-893b0e7841d7 details .accordion__content a',
            event: {
                event: 'user_interaction',
                component: 'faq',
                element: 'link',
                action: 'click',
                trigger: 'click',
                getDynamicData: (element) => { // element is the <a> tag
                    const detailsElement = element.closest('details');
                    const titleElement = detailsElement?.querySelector('summary .accordion__title');
                    return {
                         // Get the title of the FAQ item this link is inside
                        field_name: titleElement ? titleElement.textContent.trim() : 'Unknown FAQ Item', 
                        link_text: element.textContent.trim(),
                        link_url: element.href
                    };
                }
            }
        },

        // ... other homepage events will go here ...
    },
}; 